import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/suppliers', request)
}

export {get}
